import { Modal, OptionList, Stack, Text } from "@shopify/polaris";
import { useCallback, useMemo, useState } from "react";
import { useAppMutation, useAppQuery } from "../../../hooks/index.js";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";
import { OPEN_MODAL_EXPORT_ACTIONS } from "../../../constants/modalTypes.js";
import { closeModal } from "../../../store/features/modal.js";
import { export_done_modal_image } from "../../../assets/index.js";

interface IAction {
  id: string,
  name: string
}

interface IActions {
  actions: IAction[]
}

const ExportDoneTemplate = () => {
  return (
    <Stack alignment="center" spacing="extraLoose" vertical>
      <Text as="h3" variant="headingLg">Export Completed</Text>
      <div style={{ width: "210px" }}>
        <img src={export_done_modal_image} alt={"done_modal_image"} />
      </div>
    </Stack>
  )
}

const ExportActionsModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType } = useAppSelector((state) => state.modal);
  const [selected, setSelected] = useState([]);
  const [isExportDone, setExportDone] = useState(false);

  const { data, isLoading } = useAppQuery<IActions>({
    url: "/api/actions",
    reactQueryOptions: {
      enabled: isOpen && modalType === OPEN_MODAL_EXPORT_ACTIONS,
    },
  });

  const { isLoading: isLoadingExport, mutate } = useAppMutation({
    url: "/api/export",
    reactMutationOptions: {
    }
  });

  const handleClose = useCallback(() => {
    setSelected([]);
    setExportDone(false);
    dispatch(closeModal());
  }, []);

  const handleSelect = useCallback((value) => {
    setSelected(value)
  }, []);

  const options = useMemo(() => {
    if (data?.actions) {
      return data.actions.map(action => {
        return {
          value: action.id,
          label: action.name
        };
      });
    }

    return [];
  }, [data]);

  const handleExport = useCallback(() => {
    mutate({ actionIds: selected }, {
      onSuccess: () => setExportDone(true),
      onError: () => setExportDone(true),
    });
  }, [selected, mutate])


  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_EXPORT_ACTIONS}
      onClose={handleClose}
      loading={isLoading}
      title={isExportDone ? "Done!" : "Select actions"}
      primaryAction={isExportDone ? {
        content: "Ok",
        onAction: handleClose,
      } : {
        content: "Export",
        onAction: handleExport,
        loading: isLoadingExport
      }}

    >
      <Modal.Section>
        {isExportDone && <ExportDoneTemplate />}
        {!isExportDone && (
          <OptionList
            title=""
            onChange={handleSelect}
            options={options}
            selected={selected}
            allowMultiple
          />
        )}
      </Modal.Section>
    </Modal>
  );
};

export default ExportActionsModal;